stateChangeStartRun.$inject = ['$rootScope', 'ErrorFactory'];
export function stateChangeStartRun($rootScope, ErrorFactory) {

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    ErrorFactory.registerStartChange(toState, toParams);
    // A trick to keep the previous state on each state change.
    $rootScope.previousState = fromState;
  });

}
